import React from 'react'
import { Checkbox } from 'rsuite'
import { HeaderCell as RsuiteHeaderCell } from 'rsuite-table'

type CheckHeaderCellProps = {
  checkedKeys: any[],
  data: any[],
  isNoIndeterminate?: boolean,
  onCheckAllChange: (checked: boolean) => void
}

const CheckHeaderCell: React.FC<CheckHeaderCellProps> = ({
  checkedKeys,
  data,
  isNoIndeterminate,
  onCheckAllChange,
  ...props
}) => {
  const isAllChecked = checkedKeys.length === data.length && data.length > 0
  const isIndeterminate = checkedKeys.length > 0 && !isAllChecked

  return (
    // style is used by Rsuite internally to dynamically set height, width. class is not working here
    <RsuiteHeaderCell {...props} style={{ paddingTop: 0 }}>
      <div className="check-cell-Wrapper">
        <Checkbox
          inline
          checked={isAllChecked}
          indeterminate={isNoIndeterminate ? false : isIndeterminate}
          onChange={(_, checked) => onCheckAllChange(checked)}
        />
      </div>
    </RsuiteHeaderCell>
  )
}

export default CheckHeaderCell
